import { useFormikContext } from "formik";
import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import { FileError } from "../../components/FileError";
import { Antrag, DefenderDokumentStatus, DefenderUploadedDokument } from "../../interfaces/Application";
import { ApplicationFileType, useUploadDokumente } from "domain/applications/applicationMutations";
import { log } from "common/Logger";
import FileNameLabel from "components/FileNameLabel";

const MainDataDocuments: React.VFC = () => {
  const { setFieldValue, values } = useFormikContext<Antrag>();
  const { mutate: uploadDokument } = useUploadDokumente();

  const handleFileUpload = (file: File, subject: string, logItem: string, fieldValueName: string) => {
    uploadDokument(
      { datei: file, subject: subject, installationsUnternehmenId: values.installationsUnternehmenId },
      {
        onSuccess: (data) => {
          log.debug({ obj: data }, `${logItem} hochgeladen`);
          const dud: DefenderUploadedDokument = {
            documentId: data.documentId,
            dateiName: file.name,
            subject: data.subject,
            status: DefenderDokumentStatus.NotChecked,
            installationsUnternehmenId: values.installationsUnternehmenId,
          };
          setFieldValue(fieldValueName, dud);
        },
        onError: (err) => {
          log.error({ obj: err }, `Fehler beim Hochladen des/r ${logItem}`);
        },
      }
    );
  };

  const handleBetriebsHaftplichtFileSelection: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.currentTarget.files && e.currentTarget.files.length > 0) {
      const file = e.currentTarget.files[0];
      const subject = `${values.installationsUnternehmen.name}:${ApplicationFileType.Betriebshaftplicht}`;
      const logItem = "Betriebshaftpflicht";
      const fieldValueName = "betriebsHaftplichtDatei";
      handleFileUpload(file, subject, logItem, fieldValueName);
    }
  };

  const handleGewerbeAnmeldungFileSelection: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.currentTarget.files && e.currentTarget.files.length > 0) {
      const file = e.currentTarget.files[0];
      const subject = `${values.installationsUnternehmen.name}:${ApplicationFileType.Gewerbeanmeldung}`;
      const logItem = "Gewerbeanmeldung";
      const fieldValueName = "gewerbeAnmeldungDatei";
      handleFileUpload(file, subject, logItem, fieldValueName);
    }
  };

  const handleHandwerksrollenEintragungFileSelection: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.currentTarget.files && e.currentTarget.files.length > 0) {
      const file = e.currentTarget.files[0];
      const subject = `${values.installationsUnternehmen.name}:${ApplicationFileType.Handwerksrolleneintragung}`;
      const logItem = "Handwerksrolleneintragung";
      const fieldValueName = "handwerksrollenEintragungDatei";
      handleFileUpload(file, subject, logItem, fieldValueName);
    }
  };

  return (
    <>
      <Row>
        <Col>
          <Form.File
            label="Betriebshaftpflicht"
            onChange={handleBetriebsHaftplichtFileSelection}
            data-browse="Datei auswählen"
          />
          <FileError errorFieldName="betriebsHaftplichtDatei" />
        </Col>
      </Row>
      <FileNameLabel defenderUploadedDokument={values.betriebsHaftplichtDatei} />
      <Row>
        <Col>
          <Form.File
            label="Gewerbeanmeldung"
            onChange={handleGewerbeAnmeldungFileSelection}
            data-browse="Datei auswählen"
          />
          <FileError errorFieldName="gewerbeAnmeldungDatei" />
        </Col>
      </Row>
      <FileNameLabel defenderUploadedDokument={values.gewerbeAnmeldungDatei} />
      <Row>
        <Col>
          <Form.File
            label="Handwerksrolleneintragung"
            onChange={handleHandwerksrollenEintragungFileSelection}
            data-browse="Datei auswählen"
          />
          <FileError errorFieldName="handwerksrollenEintragungDatei" />
        </Col>
      </Row>
      <FileNameLabel defenderUploadedDokument={values.handwerksrollenEintragungDatei} />
    </>
  );
};

export default MainDataDocuments;
